/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_TitleInputs */

const en_cp_ch_title = /** @type {(inputs: Cp_Ch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A national competition every semester end`)
};

const id_cp_ch_title = /** @type {(inputs: Cp_Ch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompetisi nasional tiap akhir semester`)
};

/**
* | output |
* | --- |
* | "A national competition every semester end" |
*
* @param {Cp_Ch_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_title = /** @type {((inputs?: Cp_Ch_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_title(inputs)
	return en_cp_ch_title(inputs)
});